// import {
//     Formik,
//     // Field
// } from 'formik';
// import { useEffect, useState } from 'react';
// import * as Yup from 'yup';
// import { ReactComponent as Facebook } from '../assets/facebook.svg';
// import { ReactComponent as Google } from '../assets/google.svg';
// import { Link, Navigate, useNavigate } from 'react-router-dom';
// import { RegContainer, RegForms, RegisterSection } from '../components/Authentication/AuthStyles';
// // import logo from '../assets/bigLogo.svg';
// import {
//     Backbutton,
//     HeaderContainer,
// } from '../components/LandingPageComponents/styles/HeaderStyles';
// import { backbtn } from './dashboard/components/Icons';
// import {
//     Box,
//     Heading,
//     Text,
//     Spinner,
//     FormControl,
//     FormLabel,
//     InputGroup,
//     InputLeftElement,
//     Input,
//     Flex,
// } from '@chakra-ui/react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useScreenWidth } from 'hooks/useScreenWidth';
// import RegForm from 'components/LandingPageComponents/desktop/RegForm';
// import {
//     useGetCitiesByStateId,
//     useGetCountries,
//     useGetStatesByCountryId,
// } from 'hooks/useGetLocations';
// import CustomSelect from 'components/CustomSelect';
// import { AiOutlineMail } from 'react-icons/ai';
// import InputText from 'components/Input';
// import { userReg } from 'redux/actions/authActions';
// import { LOGOUT } from 'redux/actionTypes';
// import { getCurrencyCodeForCountry } from 'utils/utils';
// import CustomMultiSelect from 'components/CustomMultiSelect';
// import { logoutUser } from 'services/authservices';

// // import PhoneInput from 'react-phone-number-input';
// // import PhoneInputField from '../components/Authentication/PhoneInputField';

// const Register = () => {
//     const [selectedLocations, setSelectedLocations] = useState({
//         country: null,
//         state: null,
//         city: null,
//     });

//     const countries = useGetCountries();

//     const states = useGetStatesByCountryId(selectedLocations?.country?.value);
//     const cities = useGetCitiesByStateId(
//         selectedLocations?.state?.value,
//         selectedLocations?.country?.value,
//     );
//     const validationSchema = Yup.object().shape({
//         email: Yup.string()
//             .required('An email address is required')
//             .email('Enter a valid email address'),
//         password: Yup.string().required('Enter a password'),
//         phone: Yup.string()
//             .min(10, 'Phone number can not be less than 10 characters')
//             // .max(10, 'Phone number cannot exceed 10 characters')
//             .required('Enter a Phone number'),
//         productCategory: Yup.array()
//             .min(1, 'Select at least one category')
//             .required('Categories are required'),
//         first_name: Yup.string().required('First name is required'),
//         last_name: Yup.string().required('Last name is required'),
//         // store_address: Yup.string().required('Store address is required'),
//     });

//     const initialValues = { email: '', password: '', productCategory: [], phone: '', terms: false };
//     let navigate = useNavigate();
//     const dispatch = useDispatch();
//     const regReducer = useSelector((state) => state.regReducer);
//     const { user, loading } = regReducer;

//     const screen = useScreenWidth();

//     useEffect(() => {
//         if (user) {
//             navigate(`/signup-verify`);
//         }
//     }, [user, navigate]);

//     useEffect(() => {
//         dispatch({ type: LOGOUT });
//         logoutUser(dispatch);
//         localStorage.removeItem('token');
//         localStorage.removeItem('refresh_token');
//     }, [dispatch]);

//     const locations = {
//         state: states ?? [],
//         country: countries ?? [],

//         city: cities ?? [],
//     };

//     const normalizePhone = (phone, countryCode) => {
//   if (!phone) return "";

//   // Remove spaces, dashes, and parentheses
//   let cleaned = phone.replace(/\D/g, ""); // keep digits only

//   // If it starts with country code (e.g., 234 for Nigeria), strip it
//   if (cleaned.startsWith(countryCode)) {
//     cleaned = cleaned.slice(countryCode.length);
//   }

//   // If it starts with a leading 0, strip it
//   if (cleaned.startsWith("0")) {
//     cleaned = cleaned.slice(1);
//   }

//   return cleaned;
// };

//     const token = window.localStorage.getItem('token');

//     return token ? (
//         <Navigate to="/dashboard" />
//     ) : (
//         <RegContainer>
//             <RegisterSection>
//                 {screen <= 500 && (
//                     <HeaderContainer style={{ padding: 0 }}>
//                         <Backbutton onClick={() => navigate(-1)}>{backbtn}</Backbutton>
//                         <div className="menuSection"></div>
//                         <div></div>
//                     </HeaderContainer>
//                 )}
//                 {screen <= 500 && (
//                     <Box>
//                         <Heading
//                             as="h1"
//                             fontSize="32px"
//                             fontWeight="700"
//                             color="#090A0A"
//                             mt="0px"
//                             mb="8px">
//                             Create Your Account
//                         </Heading>
//                         <Text color="#090A0A" fontSize="16px" mb="10px">
//                             Welcome to Obana!
//                         </Text>
//                     </Box>
//                 )}
//                 <RegForm>
//                     <Formik
//                         enableReinitialize
//                         initialValues={initialValues}
//                         validationSchema={validationSchema}
//                         onSubmit={async (values, { setSubmitting }) => {
//                             setSubmitting(true);
//                                   const phoneRaw = values.phone;
//                                     const countryCode =
//                                       values.country?.phonecode || ''; 

//                                   const normalizedPhone = normalizePhone(
//                                     phoneRaw,
//                                     countryCode,
//                                 );

//                             let data = {
//                                 email: values.email,
//                                 phone: `${countryCode}${normalizedPhone}`,
//                                 password: values.password,
//                                 attributes: {
//                                     category_of_interest: values.productCategory,
//                                     // store_address: values.store_address,
//                                     city: values.city,
//                                     state: values.state,
//                                     country: values.country?.label,
//                                     first_name: values.first_name,
//                                     last_name: values.last_name,
//                                     customer_address: `${values.city}${values.state}${values.country?.label}`,
//                                     terms: values.terms,
//                                     currency: getCurrencyCodeForCountry(values.country?.value),
//                                 },
//                             };
//                             setSubmitting(false);
//                             dispatch(userReg(data));
//                         }}>
//                         {({
//                             values,
//                             errors,
//                             isValid,
//                             touched,
//                             handleChange,
//                             handleBlur,
//                             handleSubmit,
//                             isSubmitting,
//                             setFieldValue,
//                             setFieldTouched,
//                         }) => {
//                             return (
//                                 <div className="form-sect">
//                                     <RegForms width="100%" onSubmit={handleSubmit}>
//                                         {screen > 500 && (
//                                             <div
//                                                 style={{
//                                                     marginTop: '5rem',
//                                                     marginBottom: '2rem',
//                                                     textAlign: 'center',
//                                                 }}>
//                                                 <Heading
//                                                     color="#090A0A"
//                                                     fontSize="24px"
//                                                     lineHeight="36px">
//                                                     Sign Up
//                                                 </Heading>
//                                                 <Text
//                                                     color="#090A0A"
//                                                     fontSize="14px"
//                                                     lineHeight="24px">
//                                                     Let’s Get you up to Speed
//                                                 </Text>
//                                             </div>
//                                         )}
//                                         <Box pl={6}>
//                                             <Box
//                                                 display={'grid'}
//                                                 gridTemplateColumns={{ lg: 'repeat(2, 1fr)' }}
//                                                 gap={4}>
//                                                 {formField.map((ele, index) =>
//                                                     ele.type === 'text' ||
//                                                     ele.type === 'tel' ||
//                                                     ele.type === 'password' ? (
//                                                         <FormControl
//                                                             marginBottom="1.5rem"
//                                                             key={index}>
//                                                             <FormLabel
//                                                                 fontWeight="400"
//                                                                 fontSize="sm">
//                                                                 {ele.label}
//                                                             </FormLabel>

//                                                             <InputText
//                                                                 onBlur={handleBlur}
//                                                                 type={ele.type}
//                                                                 placeholder={ele.placeholder}
//                                                                 name={ele.name}
//                                                                 prefix={
//                                                                     ele.type === 'tel' &&
//                                                                     values?.country?.phonecode
//                                                                         ? `+${values?.country?.phonecode}`
//                                                                         : ''
//                                                                 }
//                                                                 value={values[ele.name]}
//                                                                 onChange={handleChange}
//                                                             />
//                                                             {touched[ele.name] &&
//                                                                 errors[ele.name] && (
//                                                                     <small
//                                                                         style={{
//                                                                             fontSize: '8px',
//                                                                             color: 'red',
//                                                                         }}>
//                                                                         {errors[ele.name]}
//                                                                     </small>
//                                                                 )}
//                                                         </FormControl>
//                                                     ) : ele.type === 'select' ? (
//                                                         <FormControl
//                                                             marginBottom="1.5rem"
//                                                             key={index}>
//                                                             <FormLabel
//                                                                 fontWeight="400"
//                                                                 fontSize="sm">
//                                                                 {ele.label}
//                                                             </FormLabel>
//                                                             <CustomSelect
//                                                                 placeholder={ele.placeholder}
//                                                                 fontSize="sm"
//                                                                 name={ele.name}
//                                                                 onChange={(e) => {
//                                                                     const selected = JSON.parse(
//                                                                         e.target.value,
//                                                                     );

//                                                                     if (ele.name === 'country') {
//                                                                         setFieldValue(
//                                                                             'country',
//                                                                             selected,
//                                                                         );
//                                                                     } else {
//                                                                         setFieldValue(
//                                                                             `${ele.name}`,
//                                                                             selected.label,
//                                                                         );
//                                                                     }
//                                                                     setSelectedLocations(
//                                                                         (prev) => ({
//                                                                             ...prev,
//                                                                             [ele.name]: selected,
//                                                                         }),
//                                                                     );
//                                                                 }}
//                                                                 disabled={
//                                                                     locations[ele.name]?.length <= 0
//                                                                 }
//                                                                 options={
//                                                                     ele.name === 'category'
//                                                                         ? ele.options?.map(
//                                                                               (item) => ({
//                                                                                   label: item,
//                                                                                   value: item,
//                                                                               }),
//                                                                           )
//                                                                         : locations[ele.name]
//                                                                               ?.length > 0
//                                                                         ? locations[ele.name]?.map(
//                                                                               (item) => ({
//                                                                                   label: item?.name,
//                                                                                   value: item.isoCode,
//                                                                                   phonecode:
//                                                                                       item.phonecode ??
//                                                                                       undefined,
//                                                                               }),
//                                                                           )
//                                                                         : []
//                                                                 }
//                                                             />{' '}
//                                                             {touched[ele.name] &&
//                                                                 errors[ele.name] && (
//                                                                     <small
//                                                                         style={{
//                                                                             fontSize: '8px',
//                                                                             color: 'red',
//                                                                         }}>
//                                                                         {errors[ele.name]}
//                                                                     </small>
//                                                                 )}
//                                                         </FormControl>
//                                                     ) : ele.type === 'multiselect' ? (
//                                                         <FormControl
//                                                             marginBottom="1.5rem"
//                                                             key={index}>
//                                                             <FormLabel
//                                                                 fontWeight="400"
//                                                                 fontSize="sm">
//                                                                 {ele.label}
//                                                             </FormLabel>
//                                                             <CustomMultiSelect
//                                                                 placeholder={ele.placeholder}
//                                                                 fontSize="sm"
//                                                                 name={ele.name}
//                                                                 value={values[ele.name] || []}
//                                                                 onChange={(selectedOptions) => {
//                                                                     setFieldValue(
//                                                                         'productCategory',
//                                                                         selectedOptions,
//                                                                     );
//                                                                 }}
//                                                                 options={ele.options || []}
//                                                             />
//                                                             {touched[ele.name] &&
//                                                                 errors[ele.name] && (
//                                                                     <small
//                                                                         style={{
//                                                                             fontSize: '8px',
//                                                                             color: 'red',
//                                                                         }}>
//                                                                         {errors[ele.name]}
//                                                                     </small>
//                                                                 )}
//                                                         </FormControl>
//                                                     ) : ele.type === 'email' ? (
//                                                         <FormControl
//                                                             marginBottom="1.5rem"
//                                                             key={index}>
//                                                             <FormLabel
//                                                                 fontWeight="400"
//                                                                 fontSize="sm">
//                                                                 {ele.label}
//                                                             </FormLabel>
//                                                             <InputGroup
//                                                                 display="flex"
//                                                                 alignItems="center">
//                                                                 <InputLeftElement pointerEvents="none">
//                                                                     <AiOutlineMail color="gray.300" />
//                                                                 </InputLeftElement>
//                                                                 <Input
//                                                                     type={ele.type}
//                                                                     placeholder={ele.placeholder}
//                                                                     fontSize="sm"
//                                                                     value={values[ele.name]}
//                                                                     name={ele.name}
//                                                                     onChange={handleChange}
//                                                                 />
//                                                             </InputGroup>{' '}
//                                                             {touched[ele.name] &&
//                                                                 errors[ele.name] && (
//                                                                     <small
//                                                                         style={{
//                                                                             fontSize: '8px',
//                                                                             color: 'red',
//                                                                         }}>
//                                                                         {errors[ele.name]}
//                                                                     </small>
//                                                                 )}
//                                                         </FormControl>
//                                                     ) : (
//                                                         ''
//                                                     ),
//                                                 )}
//                                             </Box>
//                                             <Flex marginBottom={'1rem'} justifyContent={'center'}>
//                                                 <input
//                                                     type="checkbox"
//                                                     name="terms"
//                                                     id="terms"
//                                                     style={{ marginRight: '10px' }}
//                                                     value={values.terms}
//                                                     onChange={(e) => {
//                                                         setFieldValue('terms', e.target.checked);
//                                                     }}
//                                                 />
//                                                 <Text
//                                                     fontSize={'14px'}
//                                                     color={'#090A0A'}
//                                                     textAlign={'center'}>
//                                                     By signing up, you agree to our{' '}
//                                                     <Link to={''}>Terms of Service</Link>
//                                                     Policy.
//                                                 </Text>
//                                             </Flex>
//                                             <Box maxWidth={327} marginInline={'auto'}>
//                                                 <button
//                                                     type="submit"
//                                                     className="sign-in-button"
//                                                     disabled={
//                                                         loading ||
//                                                         isSubmitting ||
//                                                         !isValid ||
//                                                         !values.terms
//                                                     }>
//                                                     {!loading ? (
//                                                         'Get Started'
//                                                     ) : (
//                                                         <Spinner color="light" size="sm" />
//                                                     )}
//                                                 </button>
//                                                 <Box textAlign={'center'} fontSize={'md'}>
//                                                     {' '}
//                                                     Already have an account?{' '}
//                                                     <Text
//                                                         onClick={() => navigate(`/login`)}
//                                                         as={'span'}
//                                                         fontSize="16px"
//                                                         fontWeight="500"
//                                                         cursor={'pointer'}>
//                                                         Login
//                                                     </Text>
//                                                 </Box>
//                                                 {screen > 500 && (
//                                                     <div className="desktp-socials">
//                                                         <p>or</p>
//                                                         <div>
//                                                             <button>
//                                                                 <Google />
//                                                             </button>
//                                                         </div>
//                                                     </div>
//                                                 )}
//                                                 {screen <= 500 && (
//                                                     <div className="desktop-socials">
//                                                         <p>OR</p>
//                                                         <button>
//                                                             Sign in with Facebook <Facebook />
//                                                         </button>
//                                                         <button>
//                                                             Sign in with Google <Google />
//                                                         </button>
//                                                     </div>
//                                                 )}
//                                             </Box>
//                                         </Box>
//                                     </RegForms>
//                                 </div>
//                             );
//                         }}
//                     </Formik>
//                 </RegForm>
//             </RegisterSection>
//         </RegContainer>
//     );
// };

// export default Register;

// const formField = [
//     {
//         label: 'First Name',
//         type: 'text',
//         placeholder: 'Seun',
//         name: 'first_name',
//     },
//     {
//         label: 'Last Name',
//         type: 'text',
//         placeholder: 'Akinloye',
//         name: 'last_name',
//     },
//     {
//         label: 'Email',
//         type: 'email',
//         placeholder: 'seunakinloye@gmail.com',
//         name: 'email',
//     },
//     {
//         label: 'Password',
//         type: 'password',
//         placeholder: '*********',
//         name: 'password',
//     },
//     {
//         label: 'Country',
//         type: 'select',
//         placeholder: 'Select Country',
//         name: 'country',
//         defaultValue: 'Nigeria',
//     },
//     {
//         label: 'Phone Number',
//         type: 'tel',
//         placeholder: '90 9535 3542',
//         name: 'phone',
//     },
//     {
//         label: 'State',
//         type: 'select',
//         placeholder: 'Select State',
//         options: ['Nigeria', 'Ghana', 'Togo'],
//         name: 'state',
//     },
//     {
//         label: 'City',
//         type: 'select',
//         placeholder: 'Select City',
//         options: ['Nigeria', 'Ghana', 'Togo'],
//         name: 'city',
//     },
//     {
//         label: 'Categories of Interest',
//         type: 'multiselect',
//         placeholder: 'Select Category',
//         options: [
//             { label: 'Fashion', value: 'fashion' },
//             { label: 'Beauty', value: 'beauty' },
//             { label: 'Lifestyles', value: 'lifestyles' },
//         ],
//         name: 'productCategory',
//     },
//     // {
//     //     label: 'Store Address',
//     //     type: 'text',
//     //     placeholder: 'Lagos, Nigeria',
//     //     name: 'store_address',
//     // },
// ];

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState, useCallback, memo } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast, Toaster } from 'sonner';
import {
    Box,
    Flex,
    // HStack,
    // VStack,
    Heading,
    Text,
    Input,
    InputGroup,
    InputLeftElement,
    InputRightElement,
    FormControl,
    FormLabel,
    FormErrorMessage,
    Button,
    IconButton,
    Spinner,
    Progress,
    Divider,
    Image,
    // useBreakpointValue,
} from '@chakra-ui/react';
import {
    AiOutlineMail,
    AiOutlineEye,
    AiOutlineEyeInvisible,
    AiOutlineUser,
    AiOutlinePhone,
    AiOutlineLock,
    AiOutlineArrowLeft,
    AiOutlineArrowRight,
    AiOutlineCheck,
} from 'react-icons/ai';
import { ReactComponent as Google } from '../assets/google.svg';
import obanaLogo  from '../assets/bigLogo.svg';
// TODO: replace this import path with your actual hero image path
// import signupHero from '../assets/signupHero.png';
import CustomSelect from 'components/CustomSelect';
import CustomMultiSelect from 'components/CustomMultiSelect';
import {
    useGetCitiesByStateId,
    useGetCountries,
    useGetStatesByCountryId,
} from 'hooks/useGetLocations';
import { userReg } from 'redux/actions/authActions';
import { LOGOUT } from 'redux/actionTypes';
import { getCurrencyCodeForCountry } from 'utils/utils';
import { logoutUser } from 'services/authservices';

/* ─────────────────────────────────────────────────────────────
   BRAND TOKENS — matches LargeDashboard / DashHead
   ───────────────────────────────────────────────────────────── */

const NAVY        = '#1B3B5F';
const NAVY_DEEP   = '#0F2940';
const CYAN        = '#DCF8F9';
const INK         = '#1A2740';
const MUTED       = '#5A6B7E';
const FAINT       = '#8896AE';
const DANGER      = '#E53E3E';
// const SUCCESS     = '#10B981';
const SURFACE     = '#FFFFFF';
const SURFACE_ALT = '#F7F9FB';
const BORDER      = '#E8EDF5';

const FONT = "'Bricolage Grotesque', sans-serif";

/* ─────────────────────────────────────────────────────────────
   VALIDATION
   ───────────────────────────────────────────────────────────── */

/* Strong password: 8+ chars, 1 upper, 1 lower, 1 number */
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
const PHONE_REGEX    = /^\d{7,15}$/;  // digits only, 7-15 chars
const EMAIL_REGEX    = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const stepSchemas = {
    1: Yup.object().shape({
        first_name: Yup.string().trim().min(2, 'Too short').required('First name is required'),
        last_name:  Yup.string().trim().min(2, 'Too short').required('Last name is required'),
        email: Yup.string()
            .trim()
            .matches(EMAIL_REGEX, 'Enter a valid email')
            .required('Email is required'),
        password: Yup.string()
            .matches(PASSWORD_REGEX, 'Min 8 chars with upper, lower & number')
            .required('Password is required'),
        passwordConfirm: Yup.string()
            .oneOf([Yup.ref('password')], 'Passwords must match')
            .required('Please confirm your password'),
    }),
    2: Yup.object().shape({
        country: Yup.object().nullable().required('Select a country'),
        state:   Yup.object().nullable().required('Select a state'),
        city:    Yup.object().nullable().required('Select a city'),
        phone: Yup.string()
            .matches(PHONE_REGEX, 'Enter a valid phone number (digits only)')
            .required('Phone number is required'),
    }),
    3: Yup.object().shape({
        productCategory: Yup.array().min(1, 'Select at least one category').required(),
        terms: Yup.boolean().oneOf([true], 'You must accept the terms to continue'),
    }),
};

const fullSchema = stepSchemas[1].concat(stepSchemas[2]).concat(stepSchemas[3]);

const INITIAL_VALUES = {
    first_name:      '',
    last_name:       '',
    email:           '',
    password:        '',
    passwordConfirm: '',
    phone:           '',
    country:         null,
    state:           null,
    city:            null,
    productCategory: [],
    terms:           false,
};

/* ─────────────────────────────────────────────────────────────
   HELPERS
   ───────────────────────────────────────────────────────────── */

const normalizePhone = (phone, countryCode) => {
    if (!phone) return '';
    let cleaned = phone.replace(/\D/g, '');
    if (countryCode && cleaned.startsWith(countryCode)) {
        cleaned = cleaned.slice(countryCode.length);
    }
    if (cleaned.startsWith('0')) {
        cleaned = cleaned.slice(1);
    }
    return cleaned;
};

const passwordStrength = (pw) => {
    if (!pw) return { score: 0, label: '', color: BORDER };
    let score = 0;
    if (pw.length >= 8)            score++;
    if (/[a-z]/.test(pw))          score++;
    if (/[A-Z]/.test(pw))          score++;
    if (/\d/.test(pw))             score++;
    if (/[^a-zA-Z0-9]/.test(pw))   score++;

    if (score <= 2) return { score, label: 'Weak',   color: '#EF4444' };
    if (score <= 3) return { score, label: 'Fair',   color: '#F59E0B' };
    if (score <= 4) return { score, label: 'Good',   color: '#10B981' };
    return                { score, label: 'Strong', color: '#059669' };
};

const CATEGORIES = [
    { label: 'Fashion',    value: 'fashion' },
    { label: 'Beauty',     value: 'beauty' },
    { label: 'Lifestyles', value: 'lifestyles' },
];

const STEPS = [
    { id: 1, label: 'Account',    desc: 'Your details' },
    { id: 2, label: 'Location',   desc: 'Where you are' },
    { id: 3, label: 'Interests',  desc: 'What you sell' },
];

/* ─────────────────────────────────────────────────────────────
   FIELD PRIMITIVES (memoized to avoid iOS focus loss)
   ───────────────────────────────────────────────────────────── */

const FieldWrap = memo(function FieldWrap({ label, error, touched, required, children }) {
    const showErr = !!(touched && error);
    return (
        <FormControl isInvalid={showErr} mb="4">
            <FormLabel
                fontSize="12px"
                fontWeight="600"
                color={INK}
                mb="2"
                fontFamily={FONT}
            >
                {label} {required && <Box as="span" color={DANGER}>*</Box>}
            </FormLabel>
            {children}
            {showErr && (
                <FormErrorMessage fontSize="12px" mt="1.5" color={DANGER}>
                    {error}
                </FormErrorMessage>
            )}
        </FormControl>
    );
});

const TextField = memo(function TextField({
    name, label, type = 'text', placeholder, autoComplete,
    inputMode, required, leftIcon, prefix, value, error, touched,
    onChange, onBlur,
}) {
    return (
        <FieldWrap label={label} error={error} touched={touched} required={required}>
            <InputGroup>
                {leftIcon && (
                    <InputLeftElement pointerEvents="none" color={FAINT} h="44px">
                        {leftIcon}
                    </InputLeftElement>
                )}
                {prefix && (
                    <InputLeftElement
                        pointerEvents="none"
                        h="44px"
                        w="auto"
                        pl="3"
                        pr="2"
                        fontSize="14px"
                        color={MUTED}
                        fontWeight="600"
                    >
                        {prefix}
                    </InputLeftElement>
                )}
                <Input
                    name={name}
                    type={type}
                    value={value || ''}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder={placeholder}
                    autoComplete={autoComplete}
                    inputMode={inputMode}
                    h="44px"
                    fontSize="14px"
                    bg={SURFACE_ALT}
                    border="1px solid"
                    borderColor={touched && error ? DANGER : BORDER}
                    borderRadius="10px"
                    pl={leftIcon ? '40px' : prefix ? `${48 + (prefix.length * 8)}px` : '14px'}
                    color={INK}
                    fontFamily={FONT}
                    _placeholder={{ color: FAINT, fontSize: '12px' }}
                    _hover={{ borderColor: touched && error ? DANGER : NAVY }}
                    _focus={{
                        borderColor: touched && error ? DANGER : NAVY,
                        bg:          SURFACE,
                        boxShadow:   `0 0 0 3px ${touched && error ? `${DANGER}22` : CYAN}`,
                    }}
                    aria-invalid={!!(touched && error)}
                    aria-required={required}
                />
            </InputGroup>
        </FieldWrap>
    );
});

const PasswordField = memo(function PasswordField({
    name, label, placeholder, autoComplete, value, error, touched, onChange, onBlur,
    showStrength,
}) {
    const [visible, setVisible] = useState(false);
    const strength = useMemo(() => passwordStrength(value), [value]);

    return (
        <FieldWrap label={label} error={error} touched={touched} required>
            <InputGroup>
                <InputLeftElement pointerEvents="none" h="44px" color={FAINT}>
                    <AiOutlineLock size={16} />
                </InputLeftElement>
                <Input
                    name={name}
                    type={visible ? 'text' : 'password'}
                    value={value || ''}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder={placeholder}
                    autoComplete={autoComplete}
                    h="44px"
                    fontSize="14px"
                    bg={SURFACE_ALT}
                    border="1px solid"
                    borderColor={touched && error ? DANGER : BORDER}
                    borderRadius="10px"
                    pl="40px"
                    pr="44px"
                    color={INK}
                    fontFamily={FONT}
                    _placeholder={{ color: FAINT, fontSize: '12px' }}
                    _hover={{ borderColor: touched && error ? DANGER : NAVY }}
                    _focus={{
                        borderColor: touched && error ? DANGER : NAVY,
                        bg:          SURFACE,
                        boxShadow:   `0 0 0 3px ${touched && error ? `${DANGER}22` : CYAN}`,
                    }}
                    aria-invalid={!!(touched && error)}
                />
                <InputRightElement h="44px">
                    <IconButton
                        aria-label={visible ? 'Hide password' : 'Show password'}
                        icon={visible ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                        onClick={() => setVisible((v) => !v)}
                        variant="ghost"
                        size="sm"
                        color={MUTED}
                        _hover={{ bg: 'transparent', color: NAVY }}
                    />
                </InputRightElement>
            </InputGroup>

            {showStrength && value && (
                <Box mt="2">
                    <Flex gap="3px" mb="1.5">
                        {[0, 1, 2, 3, 4].map((i) => (
                            <Box
                                key={i}
                                flex="1"
                                h="3px"
                                borderRadius="full"
                                bg={i < strength.score ? strength.color : BORDER}
                                transition="background 0.2s ease"
                            />
                        ))}
                    </Flex>
                    {strength.label && (
                        <Text fontSize="11px" color={strength.color} fontWeight="600">
                            {strength.label} password
                        </Text>
                    )}
                </Box>
            )}
        </FieldWrap>
    );
});

/* ─────────────────────────────────────────────────────────────
   STEPPER (progress indicator)
   ───────────────────────────────────────────────────────────── */

const Stepper = memo(function Stepper({ currentStep }) {
    return (
        <Box mb="6">
            <Flex justify="space-between" mb="3">
                {STEPS.map((s) => {
                    const isDone   = s.id < currentStep;
                    const isActive = s.id === currentStep;
                    return (
                        <Flex key={s.id} direction="column" align="center" flex="1">
                            <Flex
                                w="32px"
                                h="32px"
                                borderRadius="full"
                                align="center"
                                justify="center"
                                bg={isDone ? NAVY : isActive ? CYAN : SURFACE_ALT}
                                color={isDone ? 'white' : isActive ? NAVY : FAINT}
                                border={isActive ? '2px solid' : '1px solid'}
                                borderColor={isActive ? NAVY : isDone ? NAVY : BORDER}
                                fontSize="13px"
                                fontWeight="700"
                                fontFamily={FONT}
                                transition="all 0.2s ease"
                                aria-current={isActive ? 'step' : undefined}
                            >
                                {isDone ? <AiOutlineCheck size={14} /> : s.id}
                            </Flex>
                            <Text
                                fontSize="11px"
                                color={isActive ? NAVY : isDone ? NAVY : FAINT}
                                fontWeight="600"
                                mt="1.5"
                                textAlign="center"
                                display={{ base: 'none', sm: 'block' }}
                            >
                                {s.label}
                            </Text>
                        </Flex>
                    );
                })}
            </Flex>
            <Progress
                value={((currentStep - 1) / (STEPS.length - 1)) * 100}
                size="xs"
                bg={BORDER}
                borderRadius="full"
                sx={{
                    '& > div': {
                        background: `linear-gradient(90deg, ${NAVY} 0%, ${NAVY_DEEP} 100%)`,
                        transition: 'width 0.3s ease',
                    },
                }}
                aria-label={`Step ${currentStep} of ${STEPS.length}`}
            />
        </Box>
    );
});

/* ─────────────────────────────────────────────────────────────
   STEP 1 — ACCOUNT
   ───────────────────────────────────────────────────────────── */

const StepAccount = memo(function StepAccount({ values, errors, touched, handleChange, handleBlur }) {
    return (
        <Box>
            <Heading fontSize="20px" fontWeight="800" color={INK} fontFamily={FONT} mb="1">
                Let's get to know you
            </Heading>
            <Text fontSize="13px" color={FAINT} mb="6">
                Start by telling us your name and creating a login.
            </Text>

            <Box display="grid" gridTemplateColumns={{ base: '1fr', md: '1fr 1fr' }} gap="3">
                <TextField
                    name="first_name"
                    label="First Name"
                    placeholder="Seun"
                    autoComplete="given-name"
                    leftIcon={<AiOutlineUser size={16} />}
                    required
                    value={values.first_name}
                    error={errors.first_name}
                    touched={touched.first_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                <TextField
                    name="last_name"
                    label="Last Name"
                    placeholder="Akinloye"
                    autoComplete="family-name"
                    leftIcon={<AiOutlineUser size={16} />}
                    required
                    value={values.last_name}
                    error={errors.last_name}
                    touched={touched.last_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
            </Box>

            <TextField
                name="email"
                label="Email Address"
                type="email"
                placeholder="seun@example.com"
                autoComplete="email"
                inputMode="email"
                leftIcon={<AiOutlineMail size={16} />}
                required
                value={values.email}
                error={errors.email}
                touched={touched.email}
                onChange={handleChange}
                onBlur={handleBlur}
            />

            <PasswordField
                name="password"
                label="Password"
                placeholder="At least 8 characters"
                autoComplete="new-password"
                showStrength
                value={values.password}
                error={errors.password}
                touched={touched.password}
                onChange={handleChange}
                onBlur={handleBlur}
            />

            <PasswordField
                name="passwordConfirm"
                label="Confirm Password"
                placeholder="Re-enter your password"
                autoComplete="new-password"
                value={values.passwordConfirm}
                error={errors.passwordConfirm}
                touched={touched.passwordConfirm}
                onChange={handleChange}
                onBlur={handleBlur}
            />
        </Box>
    );
});

/* ─────────────────────────────────────────────────────────────
   STEP 2 — LOCATION
   ───────────────────────────────────────────────────────────── */

const StepLocation = memo(function StepLocation({
    values, errors, touched, setFieldValue, setFieldTouched, handleChange, handleBlur, locations,
}) {
    const onLocationChange = useCallback(
        (field, selectedJson) => {
            const selected = typeof selectedJson === 'string' ? JSON.parse(selectedJson) : selectedJson;
            setFieldValue(field, selected);
            // Reset downstream fields
            if (field === 'country') {
                setFieldValue('state', null);
                setFieldValue('city', null);
            }
            if (field === 'state') {
                setFieldValue('city', null);
            }
        },
        [setFieldValue]
    );

    return (
        <Box>
            <Heading fontSize="20px" fontWeight="800" color={INK} fontFamily={FONT} mb="1">
                Where are you based?
            </Heading>
            <Text fontSize="13px" color={FAINT} mb="6">
                We use this to set your currency and help match you with local suppliers.
            </Text>

            <Box display="grid" gridTemplateColumns={{ base: '1fr', md: '1fr 1fr' }} gap="3">
                <FieldWrap label="Country" error={errors.country} touched={touched.country} required>
                    <CustomSelect
                        name="country"
                        placeholder="Select country"
                        fontSize="sm"
                        onChange={(e) => onLocationChange('country', e.target.value)}
                        options={(locations.country ?? []).map((c) => ({
                            label:     c.name,
                            value:     c.isoCode,
                            phonecode: c.phonecode,
                        }))}
                    />
                </FieldWrap>

                <FieldWrap label="State" error={errors.state} touched={touched.state} required>
                    <CustomSelect
                        name="state"
                        placeholder={values.country ? 'Select state' : 'Pick a country first'}
                        fontSize="sm"
                        disabled={!values.country || (locations.state?.length ?? 0) === 0}
                        onChange={(e) => onLocationChange('state', e.target.value)}
                        options={(locations.state ?? []).map((s) => ({
                            label: s.name,
                            value: s.isoCode,
                        }))}
                    />
                </FieldWrap>

                <FieldWrap label="City" error={errors.city} touched={touched.city} required>
                    <CustomSelect
                        name="city"
                        placeholder={values.state ? 'Select city' : 'Pick a state first'}
                        fontSize="sm"
                        disabled={!values.state || (locations.city?.length ?? 0) === 0}
                        onChange={(e) => onLocationChange('city', e.target.value)}
                        options={(locations.city ?? []).map((c) => ({
                            label: c.name,
                            value: c.name,
                        }))}
                    />
                </FieldWrap>

                <TextField
                    name="phone"
                    label="Phone Number"
                    type="tel"
                    inputMode="tel"
                    placeholder={values.country ? '8012345678' : 'Pick a country first'}
                    autoComplete="tel-national"
                    prefix={values.country?.phonecode ? `+${values.country.phonecode}` : ''}
                    leftIcon={!values.country?.phonecode ? <AiOutlinePhone size={16} /> : undefined}
                    required
                    value={values.phone}
                    error={errors.phone}
                    touched={touched.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
            </Box>
        </Box>
    );
});

/* ─────────────────────────────────────────────────────────────
   STEP 3 — INTERESTS
   ───────────────────────────────────────────────────────────── */

const StepInterests = memo(function StepInterests({
    values, errors, touched, setFieldValue, setFieldTouched,
}) {
    return (
        <Box>
            <Heading fontSize="20px" fontWeight="800" color={INK} fontFamily={FONT} mb="1">
                What do you sell?
            </Heading>
            <Text fontSize="13px" color={FAINT} mb="6">
                Select the categories you're interested in. You can change these later.
            </Text>

            <FieldWrap
                label="Categories of Interest"
                error={errors.productCategory}
                touched={touched.productCategory}
                required
            >
                <CustomMultiSelect
                    name="productCategory"
                    placeholder="Pick one or more"
                    value={values.productCategory || []}
                    onChange={(selected) => {
                        setFieldValue('productCategory', selected);
                        setFieldTouched('productCategory', true);
                    }}
                    options={CATEGORIES}
                />
            </FieldWrap>

            {/* Terms */}
            <Box
                mt="6"
                p="14px 16px"
                bg={SURFACE_ALT}
                borderRadius="12px"
                border="1px solid"
                borderColor={touched.terms && errors.terms ? DANGER : BORDER}
            >
                <Flex gap="10px" align="flex-start">
                    <Box pt="2px">
                        <input
                            type="checkbox"
                            id="terms"
                            name="terms"
                            checked={!!values.terms}
                            onChange={(e) => setFieldValue('terms', e.target.checked)}
                            style={{
                                width: '16px',
                                height: '16px',
                                accentColor: NAVY,
                                cursor: 'pointer',
                            }}
                            aria-required="true"
                        />
                    </Box>
                    <Box flex="1">
                        <Text
                            as="label"
                            htmlFor="terms"
                            fontSize="13px"
                            color={INK}
                            lineHeight="1.5"
                            cursor="pointer"
                            display="block"
                        >
                            I agree to the{' '}
                            <Box
                                as={Link}
                                to="/terms"
                                color={NAVY}
                                fontWeight="700"
                                _hover={{ textDecoration: 'underline' }}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Terms of Service
                            </Box>
                            {' and '}
                            <Box
                                as={Link}
                                to="/privacy"
                                color={NAVY}
                                fontWeight="700"
                                _hover={{ textDecoration: 'underline' }}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Privacy Policy
                            </Box>
                            .
                        </Text>
                        {touched.terms && errors.terms && (
                            <Text fontSize="11px" color={DANGER} mt="2">
                                {errors.terms}
                            </Text>
                        )}
                    </Box>
                </Flex>
            </Box>
        </Box>
    );
});

/* ─────────────────────────────────────────────────────────────
   LOCATION SYNC — small helper to keep cascading state in sync
   without violating Rules of Hooks inside Formik's render prop.
   ───────────────────────────────────────────────────────────── */

const LocationSync = memo(function LocationSync({ country, state, city, onSync }) {
    useEffect(() => {
        onSync({ country, state, city });
    }, [country, state, city, onSync]);
    return null;
});

/* ─────────────────────────────────────────────────────────────
   MAIN
   ───────────────────────────────────────────────────────────── */

const Register = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const regReducer = useSelector((state) => state.regReducer);
    const { user, loading, error: regError } = regReducer ?? {};

    const [step, setStep] = useState(1);

    /* Cascading location data */
    const [selectedLocations, setSelectedLocations] = useState({
        country: null,
        state:   null,
        city:    null,
    });

    const countries = useGetCountries();
    const states    = useGetStatesByCountryId(selectedLocations?.country?.value);
    const cities    = useGetCitiesByStateId(
        selectedLocations?.state?.value,
        selectedLocations?.country?.value
    );

    const locations = useMemo(
        () => ({
            country: countries ?? [],
            state:   states ?? [],
            city:    cities ?? [],
        }),
        [countries, states, cities]
    );

    /* Clear any stale auth on mount — ONCE, ignore the dispatch identity dep */
    useEffect(() => {
        dispatch({ type: LOGOUT });
        logoutUser(dispatch);
        try {
            localStorage.removeItem('token');
            localStorage.removeItem('refresh_token');
        } catch { /* ignore */ }
    }, []);

    /* Navigate when registration succeeds */
    useEffect(() => {
        if (user) {
            toast.success('Account created! Check your email to verify.');
            navigate('/signup-verify');
        }
    }, [user, navigate]);

    /* Surface backend errors as toasts */
    useEffect(() => {
        if (regError) {
            toast.error(
                typeof regError === 'string'
                    ? regError
                    : regError?.message ?? 'Registration failed. Please try again.'
            );
        }
    }, [regError]);

    const handleNextStep = useCallback(
        async (validateForm, setTouched, currentValues) => {
            const errs = await validateForm();
            const schema = stepSchemas[step];
            const fieldsInStep = Object.keys(schema.fields);

            const stepErrors = Object.fromEntries(
                fieldsInStep.filter((f) => errs[f]).map((f) => [f, errs[f]])
            );

            if (Object.keys(stepErrors).length > 0) {
                // Touch all fields in this step so errors show
                setTouched(
                    Object.fromEntries(fieldsInStep.map((f) => [f, true])),
                    true
                );
                toast.error('Please fix the highlighted fields before continuing.');
                return;
            }

            setStep((s) => Math.min(s + 1, STEPS.length));
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        [step]
    );

    const handleSubmit = useCallback(
        async (values, { setSubmitting }) => {
            try {
                const countryCode = values.country?.phonecode ?? '';
                const normalized  = normalizePhone(values.phone, countryCode);

                const data = {
                    email:    values.email.trim().toLowerCase(),
                    phone:    `+${countryCode}${normalized}`,
                    password: values.password,
                    attributes: {
                        category_of_interest: values.productCategory,
                        city:                 values.city?.label ?? '',
                        state:                values.state?.label ?? '',
                        country:              values.country?.label ?? '',
                        first_name:           values.first_name.trim(),
                        last_name:            values.last_name.trim(),
                        customer_address:     [values.city?.label, values.state?.label, values.country?.label]
                            .filter(Boolean)
                            .join(', '),
                        terms:                values.terms,
                        currency:             getCurrencyCodeForCountry(values.country?.value),
                    },
                };

                await dispatch(userReg(data));
            } catch (err) {
                toast.error(err?.message ?? 'Something went wrong. Please try again.');
            } finally {
                setSubmitting(false);
            }
        },
        [dispatch]
    );

    const handleGoogleSignIn = useCallback(() => {
        // TODO: wire to your Google OAuth flow
        toast.info('Google sign-in coming soon.');
    }, []);

    /* Bail to dashboard if already logged in */
    const token = useMemo(() => {
        try { return window.localStorage.getItem('token'); } catch { return null; }
    }, []);

    /* Important: token check happens here, BEFORE the logout effect would run,
       because if already logged in we navigate away and the component unmounts. */
    if (token && !loading) {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <>
            <Toaster
                position="top-right"
                richColors
                closeButton
                duration={4500}
                toastOptions={{
                    style: {
                        fontFamily: FONT,
                        fontSize:   '13px',
                        borderRadius: '12px',
                    },
                }}
            />

            <Flex minH="100vh" bg={SURFACE} fontFamily={FONT}>
                {/* ──────────── LEFT PANEL — desktop only ──────────── */}
                <Flex
                    display={{ base: 'none', lg: 'flex' }}
                    flex="0 0 44%"
                    bg={CYAN}
                    position="relative"
                    overflow="hidden"
                    direction="column"
                    px={{ lg: '40px', xl: '56px' }}
                    py={{ lg: '40px', xl: '56px' }}
                >
                    {/* Logo */}
                    <Box position="relative" zIndex={2}>
                        <Image
                            src={obanaLogo}
                            alt="Obana"
                            h="32px"
                            style={{ width: 'auto', height: '32px' }}
                        />
                    </Box>

                    {/* Headline */}
                    <Heading
                        position="relative"
                        zIndex={2}
                        mt={{ lg: '48px', xl: '64px' }}
                        fontSize={{ lg: '32px', xl: '40px' }}
                        fontWeight="800"
                        color={NAVY}
                        fontFamily={FONT}
                        letterSpacing="-0.02em"
                        lineHeight="1.1"
                        maxW="360px"
                    >
                        Start Your Journey to{' '}
                        <Box as="span" color={NAVY_DEEP}>
                            Entrepreneurship
                        </Box>
                    </Heading>

                    {/* Hero image — fills the rest, anchored to bottom */}
                    <Box
                        position="absolute"
                        bottom="0"
                        left="0"
                        right="0"
                        top="0"
                        zIndex={1}
                        pointerEvents="none"
                    >
                        <Image
                            // src={signupHero}
                            alt=""
                            position="absolute"
                            bottom="0"
                            left="50%"
                            transform="translateX(-50%)"
                            maxW="100%"
                            maxH="85%"
                            objectFit="contain"
                            objectPosition="bottom center"
                            style={{ width: 'auto', height: 'auto' }}
                        />
                    </Box>
                </Flex>

                {/* ──────────── RIGHT PANEL — form ──────────── */}
                <Box
                    flex="1"
                    bg={SURFACE_ALT}
                    overflowY="auto"
                    maxH="100vh"
                >
                    <Box maxW="560px" mx="auto" px={{ base: '16px', md: '32px' }} py={{ base: '24px', md: '48px' }}>
                        {/* Back button on mobile */}
                        <Flex
                            display={{ base: 'flex', lg: 'none' }}
                            align="center"
                            justify="space-between"
                            mb="16px"
                        >
                            <IconButton
                                aria-label="Go back"
                                icon={<AiOutlineArrowLeft />}
                                onClick={() => (step > 1 ? setStep((s) => s - 1) : navigate(-1))}
                                variant="ghost"
                                color={INK}
                                _hover={{ bg: SURFACE }}
                            />
                            <Image
                                src={obanaLogo}
                                alt="Obana"
                                h="24px"
                                style={{ width: 'auto', height: '24px' }}
                            />
                            <Box w="40px" />
                        </Flex>

                        {/* Header */}
                        <Box mb="6" textAlign={{ base: 'left', md: 'center' }}>
                            <Heading
                                fontSize={{ base: '24px', md: '28px' }}
                                fontWeight="800"
                                color={INK}
                                fontFamily={FONT}
                                letterSpacing="-0.02em"
                                mb="2"
                            >
                                Create your account
                            </Heading>
                            <Text fontSize="14px" color={MUTED}>
                                Welcome to Obana — join thousands of merchants growing their business.
                            </Text>
                        </Box>

                        {/* Card */}
                        <Box
                            bg={SURFACE}
                            borderRadius="20px"
                            border="1px solid"
                            borderColor={BORDER}
                            p={{ base: '20px', md: '32px' }}
                            boxShadow="0 2px 16px rgba(27,59,95,0.06)"
                        >
                        <Stepper currentStep={step} />

                        <Formik
                            initialValues={INITIAL_VALUES}
                            validationSchema={fullSchema}
                            validateOnChange={false}
                            validateOnBlur={true}
                            onSubmit={handleSubmit}
                        >
                            {({
                                values, errors, touched, isSubmitting, isValid,
                                handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched,
                                validateForm, setTouched,
                            }) => (
                                <form onSubmit={handleSubmit} noValidate>
                                    <LocationSync
                                        country={values.country}
                                        state={values.state}
                                        city={values.city}
                                        onSync={setSelectedLocations}
                                    />

                                    {step === 1 && (
                                        <StepAccount
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                        />
                                    )}

                                    {step === 2 && (
                                        <StepLocation
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            setFieldValue={setFieldValue}
                                            setFieldTouched={setFieldTouched}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            locations={locations}
                                        />
                                    )}

                                    {step === 3 && (
                                        <StepInterests
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            setFieldValue={setFieldValue}
                                            setFieldTouched={setFieldTouched}
                                        />
                                    )}

                                    {/* Step navigation */}
                                    <Flex mt="8" gap="3" direction={{ base: 'column-reverse', sm: 'row' }}>
                                        {step > 1 && (
                                            <Button
                                                type="button"
                                                onClick={() => setStep((s) => s - 1)}
                                                variant="outline"
                                                h="48px"
                                                flex="1"
                                                borderRadius="12px"
                                                borderColor={BORDER}
                                                color={INK}
                                                fontWeight="700"
                                                fontSize="14px"
                                                leftIcon={<AiOutlineArrowLeft />}
                                                _hover={{ bg: SURFACE_ALT, borderColor: NAVY }}
                                            >
                                                Back
                                            </Button>
                                        )}

                                        {step < STEPS.length ? (
                                            <Button
                                                type="button"
                                                onClick={() => handleNextStep(validateForm, setTouched, values)}
                                                h="48px"
                                                flex="1"
                                                borderRadius="12px"
                                                bg={NAVY}
                                                color="white"
                                                fontWeight="700"
                                                fontSize="14px"
                                                rightIcon={<AiOutlineArrowRight />}
                                                _hover={{ bg: NAVY_DEEP }}
                                                _active={{ bg: NAVY_DEEP }}
                                            >
                                                Continue
                                            </Button>
                                        ) : (
                                            <Button
                                                type="submit"
                                                isLoading={loading || isSubmitting}
                                                loadingText="Creating account..."
                                                spinner={<Spinner size="sm" />}
                                                h="48px"
                                                flex="1"
                                                borderRadius="12px"
                                                bg={NAVY}
                                                color="white"
                                                fontWeight="700"
                                                fontSize="14px"
                                                _hover={{ bg: NAVY_DEEP }}
                                                _disabled={{ opacity: 0.6, cursor: 'not-allowed' }}
                                            >
                                                Create account
                                            </Button>
                                        )}
                                    </Flex>
                                </form>
                            )}
                        </Formik>

                        {/* Social sign-in & login link only on step 1 to reduce noise */}
                        {step === 1 && (
                            <>
                                <Flex align="center" gap="3" my="6">
                                    <Divider borderColor={BORDER} />
                                    <Text fontSize="11px" color={FAINT} fontWeight="600" letterSpacing="0.1em">
                                        OR
                                    </Text>
                                    <Divider borderColor={BORDER} />
                                </Flex>

                                <Button
                                    type="button"
                                    onClick={handleGoogleSignIn}
                                    w="full"
                                    h="44px"
                                    variant="outline"
                                    borderColor={BORDER}
                                    color={INK}
                                    fontWeight="600"
                                    fontSize="13px"
                                    borderRadius="10px"
                                    leftIcon={<Google width="18" height="18" />}
                                    _hover={{ bg: SURFACE_ALT, borderColor: NAVY }}
                                >
                                    Continue with Google
                                </Button>
                            </>
                        )}

                        {/* Login link */}
                        <Text textAlign="center" fontSize="13px" color={MUTED} mt="6">
                            Already have an account?{' '}
                            <Box
                                as={Link}
                                to="/login"
                                color={NAVY}
                                fontWeight="700"
                                _hover={{ textDecoration: 'underline' }}
                            >
                                Sign in
                            </Box>
                        </Text>
                    </Box>
                </Box>
            </Box>
            </Flex>
        </>
    );
};

export default Register;